import { queries } from "@testing-library/react"
import axios from "axios"


// API function in addition to handle multiple header status, and to handle meta code
export const handleApiCall = (method, url, params, successHandler, onSuccessView, onFailedView) => {
  var user = JSON.parse(localStorage.getItem('user'));
  let headers = {
    "clientkey": "f92472dd39235f7c1b183685c509ad13"
  }
  let query = {}
  if (user !== null) {
    if (method === "GET") {
      query.auth_token = user.auth_token
      if (params) {
        query = { ...query, ...params }
      }
    } else {
      if (params instanceof FormData) {
        params.append("auth_token", user.auth_token);
      } else if (typeof params === "object" && params !== null) {
        params.auth_token = user.auth_token;
      }
    }
  }
  axios({
    method: method,
    url: url,
    responseType: 'json',
    data: params,
    headers: headers,
    params: query
  })
    .then(function (responseJSON) {
      // const responseJSON = await axios.post(url, params)
      //first layer status code handling
      if ((responseJSON.status == 204) || (responseJSON.status == 200)) {
        if ((responseJSON.status == 204) || (responseJSON.data.meta.code == 200)) {
          successHandler(responseJSON)
          onSuccessView(responseJSON.data.data)
        } else if (responseJSON.data.data.code == 401) {
          localStorage.removeItem('user');
          window.location.href = '/login'
        } else {

          onFailedView(responseJSON.data.meta.message)

        }

      } else {
        //failed

        onFailedView("Terjadi Kesalahan")
      }


    })
    .catch(function (error) {
      console.log("unknown : " + error);
      onFailedView("" + error.response.data.message)

      if (error.response) {
        // Request made and server responded
        console.log("error data : " + error.response.data);
        console.log("error status : " + error.response.status);
        console.log("error headers : " + error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        console.log("error requestnya = " + error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
      }

      return false

    })


}

export const handleApiCallV2 = (method, url, data, successHandler, onSuccessView, onFailedView) => {
  var user = JSON.parse(localStorage.getItem('user')) || null;
  let headers = {
    "clientkey": "f92472dd39235f7c1b183685c509ad13"
  }
  let params = {}
  if (user !== null) {
    if (method === "GET") {
      params.auth_token = user.auth_token
    } else {
      if (data instanceof FormData) {
        data.append("auth_token", user.auth_token);
      } else if (typeof data === "object" && data !== null) {
        data.auth_token = user.auth_token;
      }
    }
  }
  console.log(params);
  axios({
    method: method,
    url: url,
    responseType: 'json',
    data: data,
    headers: headers,
    params: params,
  })
    .then(function (responseJSON) {
      // const responseJSON = await axios.post(url, params)
      //first layer status code handling
      if ((responseJSON.status == 204) || (responseJSON.status == 201) || (responseJSON.status == 200)) {
        if ((responseJSON.status == 204) || (responseJSON.status == 201) || (responseJSON.data.meta.code == 200)) {
          successHandler(responseJSON)
          onSuccessView(responseJSON.data.data)
        } else if (responseJSON.data.data.code == 401) {
          localStorage.removeItem('user');
          window.location.href = '/login'
        } else {

          onFailedView(responseJSON.data.meta.message)

        }

      } else {
        //failed

        onFailedView("Terjadi Kesalahan")
      }


    })
    .catch(function (error) {
      console.log("unknown : " + error);
      onFailedView("" + error.response.data.message)

      if (error.response) {
        // Request made and server responded
        console.log("error data : " + error.response.data);
        console.log("error status : " + error.response.status);
        console.log("error headers : " + error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        console.log("error requestnya = " + error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
      }

      return false

    })


}

export const apiCall = (method, url, data, onSuccessView, onFailedView) => {
  handleApiCallV2(
    method, url, data,
    onSuccessView,
    (response) => {
      // console.log("result post ", response)
    },
    onFailedView
  )
}
